import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "contract-detail-btn"
};
const _hoisted_2 = {
  key: 1,
  class: "contract-detail-audit"
};
const _hoisted_3 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_4 = {
  style: {
    "margin-left": "30px"
  }
};
import { computed, onMounted, reactive, ref, toRaw, toRefs } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import ContractDetailEdit from "./ContractDetailEdit";
import download from "@/utils/download";
export default {
  __name: 'ContractDetail',
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object
    },
    contractAction: {
      type: String
    }
  },
  emits: ['submit'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const detailLoading = ref(false);
    const downLoading = ref(false);
    const {
      exportSettlementExcel
    } = download();
    const ContractDetailEditVisible = ref(false);
    const btnVisible = computed(() => {
      if (props.contractAction === 'detailAdd') {
        return true;
      }
      return false;
    });
    const actionVisible = computed(() => {
      if (props.contractAction === 'detailAudit') {
        return true;
      }
      return false;
    });
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const props = __props;
    const data = reactive({
      curingPriceETAll: false,
      curingPriceETCnt: 0,
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      audit: {
        settlementState: 0,
        auditDescription: null
      },
      DetailSettlement: {}
    });
    const handleCuringPriceETAllChange = val => {
      apis.uptCuringPriceEtByCId({
        cid: props.contract.id,
        curingPriceEt: val
      }).then(res => {
        loadData();
      });
    };
    const handleCuringPriceETChange = (val, id) => {
      apis.uptCuringPriceEtById({
        id,
        curingPriceEt: val
      }).then(res => {
        loadData();
      });
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const loadData = () => {
      const params = {
        contractId: props.contract.id,
        ...data.pagination
      };
      detailLoading.value = true;
      apis.querySettlementList(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          data.curingPriceETCnt = records.length > 0 ? records[0].curingPriceEtCnt : 0;
          data.curingPriceETAll = data.curingPriceETCnt === data.pagination.totalSize;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        detailLoading.value = false;
      });
    };
    const downloadSettlements = () => {
      downLoading.value = true;
      exportSettlementExcel(props.contract.id, props.contract.contractName + '.xlsx').then(res => {
        downLoading.value = false;
      }).finally(() => {
        downLoading.value = false;
      });
    };
    const handleDownload = () => {
      window.open("/filesvc/xw-assets/合同费用列表模板.xlsx");
      //window.open("http://10.174.80.86:7000/filesvc/xw-assets/合同费用列表模板.xlsx")
    };
    const fileUpload = params => {
      const formData = new FormData();
      formData.append("contractId", props.contract.id);
      formData.append("fileMap", params.file);
      const contractId = props.contract.id;
      apis.deleteByContractId({
        'contractId': contractId
      }).then(res => {
        if (!res.success) {
          ElMessage.error("商品更新失败!,请重新导入");
          return;
        } else {
          apis.importExcel(formData).then(res => {
            if (res.code == 200) {
              ElMessage.success("文件导入成功!");
            } else {
              ElMessage.error(res.msg);
            }
          }).catch(err => {
            ElMessage.error(err);
          }).finally(() => {
            loadData();
          });
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        loadData();
      });
    };

    // 删除合同清单商品
    const handleDeleteCommodity = row => {
      ElMessageBox.confirm('确定要删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteSettlementInfo({
          'id': row.id
        }).then(res => {
          if (res.success) {
            ElMessage.success('删除商品成功');
            //加载商品
            loadData();
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        });
      });
    };
    const handleDetailEdit = row => {
      data.DetailSettlement = toRefs(row);
      ContractDetailEditVisible.value = true;
    };
    const handleSubmit = () => {
      const param = {
        settlementState: 2,
        id: props.contract.id
      };
      if (!data.tableData || data.tableData.length == 0) {
        ElMessage.error("请先导入合同清单!");
        return;
      }
      apis.updateContractInfo(param).then(res => {
        if (res.success) {
          ElMessage.success('合同清单提交审核成功');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        emits('submit');
      });
    };
    const handleAudit = () => {
      const param = {
        settlementState: data.audit.settlementState,
        auditDescription: data.audit.auditDescription,
        id: props.contract.id
      };
      apis.updateContractInfo(param).then(res => {
        if (res.success) {
          ElMessage.success('合同清单审核成功');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        emits('submit');
      });
    };
    onMounted(() => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [btnVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_upload, {
        style: {
          "margin-left": "12px"
        },
        ref: "upload",
        action: "",
        "http-request": fileUpload,
        "show-file-list": false,
        "auto-upload": true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("导入", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 512), _createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        onClick: handleDownload
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("下载模版", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("提交审核", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), actionVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
        modelValue: data.audit.auditDescription,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.audit.auditDescription = $event),
        placeholder: "请输入审核意见"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_radio_group, {
        modelValue: data.audit.settlementState,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.audit.settlementState = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("通过", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("不通过", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: handleAudit
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("提交", -1)]))]),
        _: 1
      })]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        class: "listing-down",
        type: "primary",
        onClick: downloadSettlements
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("下载合同清单 ", -1)]))]),
        _: 1
      })), [[_directive_loading, downLoading.value]])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          fixed: "",
          prop: "ranking",
          label: "序号",
          width: "60"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "productCategory",
          label: "产品大类/类别",
          "min-width": "100"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "projectContent",
          label: "产品小类/项目内容",
          "min-width": "300"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "standardSpecifications",
          label: "标准规格",
          "min-width": "300"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          "show-overflow-tooltip": "true",
          prop: "unit",
          label: "报价单位"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "unitPriceExcludingTax",
          label: "不含税单价/元"
        }, {
          header: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("div", null, "不含税单价/元", -1)), _createVNode(_component_el_checkbox, {
            disabled: !actionVisible.value,
            modelValue: data.curingPriceETAll,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.curingPriceETAll = $event),
            indeterminate: data.curingPriceETCnt > 0 && data.curingPriceETCnt < data.pagination.totalSize,
            onChange: handleCuringPriceETAllChange
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("固化 ", -1)]))]),
            _: 1
          }, 8, ["disabled", "modelValue", "indeterminate"])]),
          default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
            disabled: !actionVisible.value,
            modelValue: scope.row.curingPriceEt,
            "onUpdate:modelValue": $event => scope.row.curingPriceEt = $event,
            onChange: $event => handleCuringPriceETChange($event, scope.row.id)
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]), _createElementVNode("span", null, _toDisplayString(scope.row.unitPriceExcludingTax), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "unitPriceIncludingTax",
          label: "含税单价/元"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "vatRate",
          label: "增值税率%"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "technicalStandard",
          label: "技术标准"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "supplyServiceStandard",
          label: "供货服务标准"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "warrantyPeriod",
          label: "质保期"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "materialCategory",
          label: "物料类别"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "fFiled1",
          label: "预留1"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "fFiled2",
          label: "预留2"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "remarks",
          label: "备注"
        }), btnVisible.value || actionVisible.value ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          label: "操作",
          width: "150"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => handleDetailEdit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => handleDeleteCommodity(scope.row),
            disabled: _ctx.deleteByAccessoryId
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("删除 ", -1)]))]),
            _: 1
          }, 8, ["onClick", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, detailLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(_unref(ContractDetailEdit), {
        visible: ContractDetailEditVisible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => ContractDetailEditVisible.value = $event),
        onSuccess: loadData,
        detailSettlement: data.DetailSettlement
      }, null, 8, ["visible", "detailSettlement"])], 64);
    };
  }
};